/** モバイル判定用ブレークポイント（BreakpointObserver 向け） */
export const MOBILE_BREAKPOINT = '(max-width: 768px)'
